//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import ServerAction from "@/../../../common/models/ServerAction.js";

const DidModifyTargetsAction = class DidModifyTargetsAction extends ServerAction {
  constructor(user_id, session_id, uuid) {
    super("DidModifyTargetsAction");
    this.user_id = user_id;
    this.session_id = session_id;
    this.uuid = uuid;
  }
};

export default DidModifyTargetsAction;
